import { useState } from "react";

import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Imagen1 from "../../../images/modulo12/lima1.png";
import Imagen2 from "../../../images/modulo12/lima2.png";
import Imagen3 from "../../../images/modulo12/lima3.png";

import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad5.mp3";

const Actividad8 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "1" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "1" },
  });
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[6];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[7].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[7].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[5].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[5].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>
      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-8 col-12 p-0">
          <ul>
            <li>
              Olga Quispe vivía en el campo antes de migrar a la ciudad. ¿Qué
              cosas crees que la sorprendieron cuando llegó? Márcalas con un
              check.
            </li>
            <li>
              Ahora marca la que creas que sorprendió más a Olga cuando llegó.
            </li>
            <li>
              Conversa con un compañero o compañera o familiar. Explícale por
              qué marcaste esa imagen.
            </li>
          </ul>
        </div>
      </div>
      <div className="row mt-4 align-items-center justify-content-center">
        <div className="col-lg-3 col-6 text-center">
          <input
            className={"form-check-input mb-1 form-md " + answers.ans1.valid}
            type="checkbox"
            value="1"
            checked={answers.ans1.value === "1"}
            onChange={(event) => handleAnswers(event, "ans1")}
          />
          <img src={Imagen1} className="img-fluid" alt="Peruanos" />
        </div>
        <div className="col-lg-3 col-6 text-center">
          <input
            className={"form-check-input mb-1 form-md " + answers.ans2.valid}
            type="checkbox"
            value="1"
            checked={answers.ans2.value === "1"}
            onChange={(event) => handleAnswers(event, "ans2")}
          />
          <img src={Imagen2} className="img-fluid" alt="Peruanos" />
        </div>
        <div className="col-lg-4 col-6 text-center">
          <input
            className={"form-check-input mb-1 form-md " + answers.ans3.valid}
            type="checkbox"
            value="1"
            checked={answers.ans3.value === "1"}
            onChange={(event) => handleAnswers(event, "ans3")}
          />
          <img src={Imagen3} className="img-fluid" alt="Peruanos" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que las siguientes actividades tienen como objetivo
            dialogar entre compañeros. Señale que, para ello, es necesario tomar
            posición sobre un tema. Ello implica poder sustentar nuestra
            posición con argumentos, escuchar a los demás y ser tolerante con
            posiciones distintas de las nuestras.
          </li>

          <li>
            Lea las dos primeras indicaciones: Olga Quispe vivía en el campo
            antes de migrar a la ciudad. ¿Qué cosas crees que la sorprendieron
            cuando llegó? Márcalas con un check.
          </li>

          <li>
            Pida que describan las imágenes. Por ejemplo:
            <ul>
              <li>
                “En la primera imagen vemos mucha gente en un solo lugar. Todos
                están ocupados con sus celulares. En la segunda imagen se ven
                muchos edificios, pistas y carros. Hay muy poca vegetación. En
                la tercera imagen se ve desorden, caos vehicular. No se siguen
                las normas de tránsito porque los carros paran donde está
                prohibido”.
              </li>
            </ul>
          </li>

          <li>
            Lea la siguiente indicación: Conversa con un compañero, compañera o
            familiar. Comparen sus respuestas. Explícale por qué marcaste esa
            imagen.
          </li>

          <li>
            Pida que trabajen con un niño, niña o familiar. Cada uno debe
            explicar qué imágenes escogió y por qué. Déles un
            tiempo para trabajar.
          </li>

          <li>
            Pregunte a todos quiénes marcaron la primera imagen y por qué. Haga
            lo mismo para las siguientes imágenes.
          </li>

          <li>
            Termine la actividad retomando las respuestas para explicar que las
            tres imágenes podrían sorprender a alguien que ha vivido en el campo
            pues se trata de situaciones que no son usuales en ese contexto.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
